import React, { Component } from "react";
import HttpServices from "../../utils/Http.services";
import { checkTextTranslation, checkTranslation, imageAddress, translate } from "../../utils/useful";
import Dashboard from "./Dashboard";
import Loader from 'react-loader-spinner'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import DashboardLink from "../widgets2/DashboardLink";
import BarChartSkeleton from "../widgets2/BarChartSkeleton";
import PieChartSkeleton from "../widgets2/PieChartSkeleton";
import ProfileSkeleton from "../widgets2/ProfileSkeleton";
import SkletonCart from "../widgets2/SkletonCart";
import SkeletonChart from "../widgets2/SkletonChart";
import ButtonAnimated from "../buttons/ButtonAnimated";


class SkeletonDashboardsContainer extends Component {
    state = {
        portals: [
            { label: '{{lang}}Messenger', notif: 5, window: 'messenger', icon: '/assets/icons/portals/folder2.svg', description: '{{lang}}Keep in touch with people matter to you', key: 'Messenger' },
            { label: '{{lang}}Drive', window: 'drive', icon: '/assets/icons/portals/drivetest.svg', description: '{{lang}}Keep your files safe and secure in Yonnect cloud', key: 'Drive' },
            { label: '{{lang}}Rooms', window: 'rooms', icon: '/assets/icons/portals/roomtest.png', description: '{{lang}}Video and voice rooms. Enjoy custom rooms', key: 'Rooms' },
            { label: '{{lang}}Desk', notif: 20, window: 'desk', icon: '/assets/icons/portals/desktest.svg', description: '{{lang}}Track your tasks and plans all in yonnect Desk', key: 'Desk' },
            { label: '{{lang}}Email', window: 'email', icon: '/assets/icons/portals/mailtest.png', description: '{{lang}}Enjoy social connection with people and ideas', key: 'Email' },
            { label: '{{lang}}Notebook', window: 'notebook', icon: '/assets/icons/Notebook.svg', description: '{{lang}}Keep all your notes and whiteboards here', key: 'Notebook' },
        ],

        tabs: 'applets',
        currentDashboard: { _id: 'default', mode: "dashboard", name: "Default" },
        dashboards: [],
        applets: [
            { icon: '/images/p1.png', name: 'Messenger', notif: '4', },
            { icon: '/images/p2.png', name: 'Messenger', notif: '4', },
            { icon: '/images/p3.png', name: 'Messenger', notif: '4', },
            { icon: '/images/p4.png', name: 'Messenger', notif: '4', },
            { icon: '/images/p5.png', name: 'Messenger', notif: '4', },
        ],
        hubs: [
            { icon: '/images/p1.png', name: 'Pouya Pezhman', notif: '4', },
            { icon: '/images/p2.png', name: 'Pedram Pezhman', notif: '4', },
            { icon: '/images/p3.png', name: 'Hossein Mohseni', notif: '4', },
            { icon: '/images/p4.png', name: 'Parna Azizi', notif: '4', },
            { icon: '/images/p5.png', name: 'Shahrzad Serajpour', notif: '4', },
            { icon: '/images/p6.png', name: 'Pouya Pezhman', notif: '4', },
            { icon: '/images/p7.png', name: 'Pedram Pezhman', notif: '4', },
            { icon: '/images/p8.png', name: 'Hossein Mohseni', notif: '4', },
            { icon: '/images/p1.png', name: 'Pouya Pezhman', notif: '4', },
            { icon: '/images/p2.png', name: 'Pedram Pezhman', notif: '4', },
            { icon: '/images/p3.png', name: 'Hossein Mohseni', notif: '4', },
            { icon: '/images/p4.png', name: 'Parna Azizi', notif: '4', },
            { icon: '/images/p5.png', name: 'Shahrzad Serajpour', notif: '4', },

        ],
    }

    componentDidMount() {
        // this.fetchDashboards()
        // this.portalsContainer.addEventListener('wheel', this.onWheel, true)

    }

    componentWillUnmount() {
        // this.portalsContainer.removeEventListener('wheel', this.onWheel)

    }

    onWheel = (e) => {
        if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) {
            e.stopPropagation()
        }
    }



    fetchDashboards = () => {

        this.setState({ isLoadingData: true })

        HttpServices.request('getMyDashboards', {}, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })
            if (fetchError) {
                this.setState({ pageStatus: 404 })
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            let dashboards = []
            if (fetchResult.info) {
                dashboards = fetchResult.info
            }
            this.setState({ pageStatus: 200, dashboards }, () => {
            })

        })

    }

    changeDashboard = (prop) => {
        let currentDashboard = this.state.currentDashboard
        if (prop == 'default') {
            currentDashboard = { _id: 'default', mode: "dashboard", name: "Default" }
        }
        else {
            currentDashboard = prop
        }
        this.setState({ currentDashboard })
    }
    postDashboard = (_id, name, pages, cb) => {
        let data = {
            _id: _id,
            name: name,
            page: pages,
        }

        let isEditing = data._id ? true : false
        let address = 'postDashboard'
        this.setState({ isPostingData: true })

        for (const [key, value] of Object.entries(data)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                delete data[key]
            }
        }
        data.name = name
        HttpServices.request(address, data, (fetchResult, fetchError) => {
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postFailed', description: fetchError.message })
                return
            }
            let dashboards = this.state.dashboards ?? []
            dashboards.push(fetchResult.info)
            this.setState({ dashboards })
            cb(fetchResult)
        })

    }
    addNewDashboard = (urlcode) => {
        let path = []
        path.push('settings')
        path.push('dashboards')
        path.push('new')
        this.props.addNewWindow('', { path: path, postDashboard: this.postDashboard })
    }

    setHubs = () => {
        this.setState({ tabs: "hubs" })
    }

    setApplet = () => {
        this.setState({ tabs: "applets" })
    }
    openApplet = (username, urlcode) => {
        let path = [username, urlcode]
        this.props.addNewWindow('applet', { path: path })
    }

    render() {
        let canScroll = this.props.canScroll

        return (
            <div ref={el => this.main = el} className="Dashboard no-scrollbar px-3" style={{ backgroundColor: '#f5f5f5', top: this.props.dashboardPos, overflow: canScroll ? 'auto' : 'hidden' }}>
                {/* <div ref={el => this.portalsContainer = el} className="portals-container d-flex pt-2"  >
                    {this.state.portals.map((item, index) => {

                        return (
                            <div className="portal-item  flex-1" key={index} >
                                <div className="portal-item-container px-3 pt-2 pb-3 d-flex">
                                    <div className='skeleton-box  mt-1' style={{ width: 68, aspectRatio: '1 / 1', backgroundColor: '#dedede', borderRadius: 50 }}></div>
                                    <div className="mld-3 w-100 flexcc flex-column">
                                        <div className="flexc w-100">
                                            <div className=' br-15 mt-1' style={{ width: '40%', height: 15, backgroundColor: '#dedede', }}></div>
                                        </div>

                                        <div className=' br-15 mt-2' style={{ width: '100%', height: 15, backgroundColor: '#dedede', }}></div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div> */}


                {/* <div className="w-100 bg-white " style={{ backgroundColor: '#f6f6f6', }}>
                    <div className="flexc p-4 ">
                        <div className='skeleton-box br-15 mt-1' style={{ width: 80, height: 24, backgroundColor: '#c2c2c2', }}></div>
                        <div className='br-15 mt-1 mx-2' style={{ width: 80, height: 24, backgroundColor: '#dedede', }}></div>


                    </div>

                    <div className="flexc sc-gray2 px-4" ref={el => this.portalsContainer = el} style={{ overflowX: 'auto' }}>
                        {this.state.hubs.map((item, index) => {
                            return (
                                <div key={index} className="pb-3 pt-2 px-4 prd-5" style={{ transition: 'all 0.5s', }}>
                                    <div className="flexcc flex-column" style={{ position: 'relative' }}>
                                        <div className=' mt-1' style={{ width: 50, height: 50, backgroundColor: '#dedede', borderRadius: 50 }}></div>
                                        <div className='br-15 mt-1' style={{ width: '105%', height: 18, backgroundColor: '#dedede' }}></div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                </div> */}
                {/* <div className=" w-100 py-2 my-2 px-4 position-sticky top-0 zindex-1" style={{ backgroundColor: '#f6f6f6', }}>
                    <div className="" style={{}}>
                        <div className='skeleton-box br-15 mt-1' style={{ width: 120, height: 25, backgroundColor: '#c2c2c2', }}></div>
                        <div className=' br-15 mt-1' style={{ width: '100%', height: 18, backgroundColor: '#dedede', }}></div>
                        <div className=' br-15 mt-1' style={{ width: '30%', height: 18, backgroundColor: '#dedede', }}></div>

                    </div>
                </div> */}

                <div className="px-4 pt-4">
                    <p className="text-big text-bold">{translate("Public Information")}</p>
                    <p className="text-small text-semibold ">{translate("You are not using the all features of Yonnect because you are not logged in.")}</p>

                </div>
                <div className="row m-0 pt-4">

                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <div className="dashboard-widgets pt-5 px-5" style={{ background: '' }}>
                            <p className=" text-big text-bold text-center " >{translate('Yonnect user?')}</p>
                            <p className=" text-normal mt-1 text-bold text-center " >{translate('Login to use all features')}</p>
                            <p className=" text-smaller text-center mt-3  " style={{ margin: '0px 0px 0px 0px' }}>{translate('You need to be logged in, for accessing your persolized account. If you are not a Yonnect user, You can start to use Yonnect for free. Just click the botton blow and you are good to go.')}</p>

                            <div className='mt-3 flexcc'>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => this.props.addNewWindow("authentication", {}, "center")}
                                    title={translate("Log in / Sign up")}
                                    icon='/assets/icons/arrow-right-white.svg'
                                    textColor={'#fff'}
                                    // invert={this.props.colors?.iconInvert}
                                    bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                />
                            </div>

                        </div>
                    </div>


                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <DashboardLink width={this.props.width} />
                    </div>
                    {/* <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <BarChartSkeleton width={this.props.width} />
                    </div> */}
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <PieChartSkeleton width={this.props.width} />
                    </div>
                    {/* <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <ProfileSkeleton width={this.props.width} />
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <SkletonCart width={this.props.width} />
                    </div>
                    <div className="col-12 col-md-4 col-lg-4 mb-4">
                        <SkeletonChart width={this.props.width} />
                    </div> */}
                </div>
            </div>
        )
    }
};




const mapStateToProps = state => ({ settings: state.settings, user: state.user, connection: state.connection, inbox: state.inbox, relations: state.relations })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(SkeletonDashboardsContainer);

